
<template>
  <!-- <vs-popup class="holamundo" popup-class="w-9/12" :title="title" :active.sync="popupActive"> -->
  <vx-card>
  <form>
    <div class="vx-row mb-6">
      <div class="vx-col w-full mb-4">
        <vs-input
          v-validate="'required'"
          label="عنوان"
          name="subject"
          v-model="ticket.subject"
          class="w-full"
        />
        <span class="text-danger text-sm" v-show="errors.has('subject')">وارد کردن عنوان اجباری است</span>
      </div>
      <div class="vx-col w-full mb-4">
        <div class="vx-row">
          <div class="vx-col w-full flex-inline">
            <span>اولویت:</span>
          </div>
          <div class="vx-col w-full flex-inline">
            <v-select
             :clearable="false"
              class="selectExample w-full"
              v-model="selectedTicketPriority"
              :options="TicketPriorityList"
            ></v-select>
          </div>
        </div>
      </div>
      <div class="vx-col w-full mb-4">
        <div class="vx-row">
          <div class="vx-col w-full flex-inline">
            <span>دپارتمان:</span>
          </div>
          <div class="vx-col w-full flex-inline">
            <v-select
             :clearable="false"
              class="selectExample w-full"
              v-model="selectedDepartment"
              :options="departments"
            ></v-select>
          </div>
        </div>
      </div>
      <div class="vx-col w-full mt-3 mb-4">
        <vs-textarea
          v-validate="'required'"
          label="سوال"
          name="message"
          v-model="ticket.message"
          class="w-full"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('message')"
        >وارد کردن متن سوال اجباری است</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click.prevent="submitForm">ذخیره</vs-button>
      </div>
    </div>
  </form>
  </vx-card>
  <!-- </vs-popup> -->
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
[dir="rtl"] .ltr-datepicker {
  direction: ltr;
}
[dir="rtl"] .ltr-datepicker input {
  border: 1px solid #dadada;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
<script>
import { TicketPriority } from "@/enums.js";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
export default {
  //name: "create-ticket",
  props: {},
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      //popupActive: false,
      selectedTicketPriority:null,
      departments:[],
      selectedDepartment:null,
      ticket: {}
    };
  },
  computed: {
    TicketPriorityList: function() {
      let ms = [];
      for (let [key, value] of Object.entries(TicketPriority)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    }
  },
  methods: {
    async submitForm() {
      if (!(await this.$validator.validateAll())) {
        return;
      }
      let loading = this.$vs.loading();
      this.ticket.priority=this.selectedTicketPriority.value;
      this.ticket.departmentId=this.selectedDepartment.value;
      this.$http
        .post("/api/services/app/Support/OpenTicket", this.ticket)
        .then(response => {
          if (response.data.success == true) {
            this.$router.push("/support/tickets");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    getDepartments() {
      let loading = this.$vs.loading();
      this.$http
        .get("/api/services/app/Departments/GetAll")
        .then(response => {
          this.departments = response.data.result.map(x => {
            return { value: x.id, label: x.title };
          });
          this.selectedDepartment=this.departments[0];
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
  },
  mounted() {
    this.selectedTicketPriority = this.TicketPriorityList.find(x => x.value == 0);
    this.getDepartments();
  },
  beforeRouteEnter(to, from, next) {
    // if (from.path == "/result") {
    //   next('/main')
    // }
    next();
  }
};
</script>